// Единое место форматирования для магазина.
// Валюта задаётся через .env: REACT_APP_SHOP_CURRENCY=UZS (или USD)
export const CURRENCY = process.env.REACT_APP_SHOP_CURRENCY || 'UZS';

const priceFormatter = new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: CURRENCY,
    minimumFractionDigits: CURRENCY === 'UZS' ? 0 : 2,
    maximumFractionDigits: CURRENCY === 'UZS' ? 0 : 2,
});

export const formatPrice = (value) => priceFormatter.format(Number(value) || 0);

// pluralize(5, ['позиция', 'позиции', 'позиций']) → 'позиций'
export const pluralize = (n, [one, few, many]) => {
    const mod10 = n % 10;
    const mod100 = n % 100;
    if (mod10 === 1 && mod100 !== 11) return one;
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
    return many;
};

export const QUALITY_LABELS = {
    oem: 'OEM',
    original: 'Оригинал',
    aftermarket: 'Аналог',
};

export const VEHICLE_LABELS = {
    car: 'Автомобили',
    moto: 'Мотоциклы',
    universal: 'Универсальная',
};
